import React, { useEffect } from 'react'
import { IEmployee, IProjectToEmployeeLink } from '../../starter/model/interfaces'
import style from './mainView.module.scss'
import ProjectColumn from '../../components/ProjectColumn/ProjectColumn'

import {
  useCreateProjectEmployeeLinksMutation,
  useLazyGetProjectEmployeeLinksQuery,
  useUpdateProjectEmployeeLinksMutation
} from '../../starter/api/projectEmployeeLinksApi'
import { useDrop } from 'react-dnd'
import CreatePeriod from '../../components/CreatePeriod/CreatePeriod'
import { Button } from 'antd'
import { useActions } from '../../starter/hooks/actions'
import { useAppSelector } from '../../starter/hooks/redux'
import { store } from '../../starter/redux/store'
import { useUpdateSequenceProjectMutation } from '../../starter/api/sequenceProjectApi'
import dayjs from 'dayjs'

export default function MainView() {
  const { setError, setButtonSet, setTmpPeriod, setModalData, onShowModal } = useActions()

  const modalData = useAppSelector((state) => state.modal)

  const { projects } = useAppSelector((state) => state.projects)
  const { projectEmployeeLinks } = useAppSelector((state) => state.projectEmployeeLinks)
  const { sequenceProject: sortedProjectTemplate } = useAppSelector((state) => state.sequenceProject)

  const [
    createLink,
    {
      isLoading: isLoadingCreateLink,
      isSuccess: isSuccessCreateLink,
      isError: isErrorCreateLink,
      error: errorCreateLink
    }
  ] = useCreateProjectEmployeeLinksMutation()
  const [
    updateLink,
    {
      isLoading: isLoadingUpdateLink,
      isSuccess: isSuccessUpdateLink,
      isError: isErrorUpdateLink,
      error: errorUpdateLink
    }
  ] = useUpdateProjectEmployeeLinksMutation()
  const [UpdateSequence] = useUpdateSequenceProjectMutation()
  const [getProjectEmployeeLinks] = useLazyGetProjectEmployeeLinksQuery()

  useEffect(() => {
    getProjectEmployeeLinks()
  }, [])

  useEffect(() => {
    if (isErrorCreateLink || isErrorUpdateLink) {
      setError({
        isError: true,
        message:
          // @ts-ignore
          (errorCreateLink && errorCreateLink.data) ||
          // @ts-ignore
          (errorUpdateLink && errorUpdateLink.data)
      })
    }
  }, [isErrorCreateLink, isErrorUpdateLink, errorCreateLink, errorUpdateLink])

  useEffect(() => {
    if (isSuccessCreateLink || isSuccessUpdateLink) {
      onShowModal(false)
    }
  }, [isSuccessCreateLink, isSuccessUpdateLink])

  useEffect(() => {
    const _buttonSet = modalData.buttonSet.map((button) => ({
      ...button,
      loading: isLoadingCreateLink || isLoadingUpdateLink
    }))

    setModalData({
      buttonSet: _buttonSet,
      footer: _buttonSet.map((item, index) => <Button key={index} {...item} />)
    })
  }, [isLoadingCreateLink, isLoadingUpdateLink])

  const modalDropToProjectHandler = (linkItem: IProjectToEmployeeLink): void => {
    const link =
      projectEmployeeLinks &&
      projectEmployeeLinks.find(
        (item) => item.employee._id === linkItem.employee._id && item.project._id === linkItem.project._id
      )
    onShowModal(true)
    setButtonSet([
      {
        type: 'primary',
        onClick: () => addLink(link || linkItem),
        children: 'Ok'
      },
      {
        onClick: () => onShowModal(false),
        children: 'Cancel'
      }
    ])
    setModalData({
      title: 'установите период привлечения сотрудника',
      content: <CreatePeriod onChange={setTmpPeriod} periods={link ? link.periods : []} showRange={true} />
    })
  }

  const addLink = (linkItem: IProjectToEmployeeLink) => {
    const { period: tmpPeriod, doRemovePeriods } = { ...store.getState()?.tmp }
    if (tmpPeriod || doRemovePeriods) {
      const _linkItem: IProjectToEmployeeLink = {
        ...linkItem,
        periods: tmpPeriod
          ? [...linkItem.periods.filter((p) => !doRemovePeriods.map((t) => t.id).includes(p.id)), tmpPeriod]
          : [...linkItem.periods.filter((p) => !doRemovePeriods.map((t) => t.id).includes(p.id))]
      }
      if (!linkItem._id) {
        createLink(_linkItem)
      } else {
        updateLink(_linkItem)
      }
    }
    setTmpPeriod(null)
  }

  const [, projectRef] = useDrop({
    accept: 'project',
    drop(item: IProjectToEmployeeLink | IEmployee, monitor) {
      const { sequenceProject } = { ...store.getState()?.sequenceProject }
      if (sequenceProject.length === 0) {
        UpdateSequence([item._id])
      } else {
        const curIndex = sequenceProject.findIndex((f) => f === item._id)
        if (!(curIndex + 1)) {
          const _sortedProjectTemplate = [...sequenceProject]
          _sortedProjectTemplate.push(item._id)
          UpdateSequence(_sortedProjectTemplate)
        }
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      isOverCurrent: monitor.isOver({ shallow: true })
    })
  })

  return (
    <>
      <div className={style.mainWrapper} ref={projectRef}>
        <div className={style.projectList}>
          {projects &&
            sortedProjectTemplate
              .map((item) => projects.find((p) => p._id === item))
              .map((project, index) => {
                const filteredLinks: IProjectToEmployeeLink[] = projectEmployeeLinks
                  ? projectEmployeeLinks.filter((pe) => project && pe.project._id === project._id)
                  : []
                if (project) {
                  return (
                    <ProjectColumn
                      key={project && project._id}
                      project={project}
                      ProjectToEmployeeLinks={filteredLinks || []}
                      setLink={modalDropToProjectHandler}
                      index={index}
                    />
                  )
                } else {
                  return null
                }
              })}
          {projects
            .filter((p) => !sortedProjectTemplate.includes(p._id)) // берем проекты которых нет в списке избранных
            .filter((project) => {
              // берем проекты в которых есть активные сотрудники
              let result = false
              projectEmployeeLinks
                .filter((pel) => pel.project._id === project._id)
                .forEach((pel) => {
                  const actual = pel.periods.find((p) => dayjs(p.startTime) <= dayjs() && dayjs() <= dayjs(p.endTime))
                  if (actual) {
                    result = true
                  }
                })
              return result
            })
            .map((project, index) => {
              const filteredLinks: IProjectToEmployeeLink[] = projectEmployeeLinks
                ? projectEmployeeLinks.filter((pe) => project && pe.project._id === project._id)
                : []
              if (project) {
                return (
                  <ProjectColumn
                    key={project && project._id}
                    project={project}
                    ProjectToEmployeeLinks={filteredLinks || []}
                    setLink={modalDropToProjectHandler}
                    index={index}
                    isForgotten={true}
                  />
                )
              } else {
                return null
              }
            })}
        </div>
      </div>
    </>
  )
}
